import { Checkmark } from 'react-checkmark';

const BookingStatusScreen = ({ policyId }) => {
    const serviceName = policyId === 1 ? 'Free Consultation' : policyId === 2 ? 'Lab Investigation' : 'Pharmacy Discount';

    return (
        <div>
            <Checkmark />
            <p className="text-success text-center fs-5 p-3">{serviceName} Approved Successfully</p>
        </div>
    );
};

export default BookingStatusScreen;
